export default function Footer() {
    return (
        <footer className="border-t border-black/10 mt-24 bg-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid md:grid-cols-3 gap-10">
                <div>
                    <div className="font-display text-2xl font-black tracking-tighter">
                        BUILDERS<span className="text-[#E63946]">.</span>GALLERY
                    </div>
                    <p className="text-sm text-neutral-600 mt-3 max-w-xs leading-relaxed">
                        The portfolio platform for British builders. Show your craft, share a single QR code, and win more jobs.
                    </p>
                </div>
                <div>
                    <div className="text-overline text-neutral-500 mb-3">For Builders</div>
                    <ul className="space-y-2 text-sm text-neutral-700">
                        <li>Project galleries</li>
                        <li>QR profile sharing</li>
                        <li>Customer-friendly portfolios</li>
                        <li>
                            <a href="/advertise" className="hover:text-[#E63946] font-semibold">
                                Advertise with us →
                            </a>
                        </li>
                    </ul>
                </div>
                <div>
                    <div className="text-overline text-neutral-500 mb-3">Trade Specialties</div>
                    <ul className="grid grid-cols-2 gap-y-2 text-sm text-neutral-700">
                        <li>Extensions</li>
                        <li>Renovations</li>
                        <li>Brickwork</li>
                        <li>Carpentry</li>
                        <li>Roofing</li>
                        <li>Landscaping</li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-black/10 py-5 text-center text-xs tracking-[0.2em] uppercase text-neutral-500">
                © {new Date().getFullYear()} BuildersGallery.co.uk · Built for the trade
            </div>
        </footer>
    );
}
